import React, { useContext } from "react";

import {
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { SpinnerPage } from "shared/components/spinner/page/spinnerPage";
import { AuthContext } from "shared/context/AuthContext";

import { EduPanel } from "shared/components/EduPlatform";
// import DashboardBranches from "../features/dashboard/components/Branches/DashboardBranches";
import EducationEduHero from "../features/edu-hero/components/EducationEduHero";
import EducationDashboardHeader from "../features/edu-hero/components/EducationDashboardHeader";
import DashboardUserResources from "../features/dashboard/components/DashboardUserResources";

export const Dashboard = (props) => {
  const context = useContext(AuthContext);

  const [themeVersion, setThemeVersion] = React.useState(0);

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setThemeVersion((version) => version + 1);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });

    return () => observer.disconnect();
  }, []);

  const { isLoadedDashboard, dashboard_data } = props.state;
  const dashboardData = dashboard_data?.stats ?? {};

  if (!isLoadedDashboard) {
    return (
      <SpinnerPage
        themeVersion={themeVersion}
        isLoaded={isLoadedDashboard}
        textSpinner="Dashboard"
        className="dashboard_image"
      />
    );
  }
  // if (
  //   !context.state.isAuthUser &&
  //   !isLoadedDashboard
  // ) {
  //   return (
  //     <SpinnerPage
  //       themeVersion={themeVersion}
  //       isLoaded={isLoadedDashboard}
  //       textSpinner="Dashboard"
  //       className="dashboard_image"
  //     />
  //   );
  // }

  if (
    !context.state.isAuthUser &&
    isLoadedDashboard &&
    Object.keys(dashboardData).length === 0
  ) {
    return <PageSection className="dashboard_image" />;
  }

  return (
    <PageSection>
      <Stack hasGutter>

        {context.state.isAuthUser && (
          <>
            <StackItem>
              <EducationDashboardHeader />
            </StackItem>

            <StackItem>
              <DashboardUserResources
                branches={dashboardData}
                branchesLoading={!isLoadedDashboard}
                themeVersion={themeVersion}
              />
            </StackItem>
          </>
        )}

        {/* {context.state.isAuthUser && (
          <StackItem>
            <DashboardBranches
              branches={dashboardData}
              isAuthUser
              themeVersion={themeVersion}
            />
          </StackItem>
        )} */}
        {!context.state.isAuthUser && (
          <StackItem>
            <EduPanel
              isCard={false}
              showHeader={false}
              showAction={false}
              title="Platforma edukacyjna"
              description="..."
              actionLabel="..."
              actionHref="..."
              hero={
                <EducationEduHero
                  branches={dashboardData}
                  isAuthUser={context.state.isAuthUser}
                  themeVersion={themeVersion}
                />
              }
            />
          </StackItem>
        )}
      </Stack>
    </PageSection>
  );
};

export default Dashboard;